__webpack_require__.p = "https://assets.canny.io/7d6d45e1487ba6e20e0b86cbf023ee5ed76b74e7/";